import { useTranslation } from 'react-i18next';

const images = [
  {
    src: 'https://public.readdy.ai/ai/img_res/7748a47dfe08d7454f2135c1300c057c.jpg',
    alt: 'Không gian Chợ Hẻm Asian Alley',
    span: 'col-span-2 row-span-2',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Small%20Asian%20kiosk%20stall%20with%20neatly%20arranged%20handmade%20jewelry%20accessories%20display%20wooden%20shelves%20warm%20golden%20lighting%20clean%20organized%20merchandise&width=600&height=400&seq=gallery_chohem_02&orientation=landscape',
    alt: 'Kiosk trang sức phụ kiện',
    span: 'col-span-1 row-span-1',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Asian%20nail%20salon%20kiosk%20small%20professional%20setup%20manicure%20station%20colorful%20nail%20polish%20display%20clean%20modern%20interior%20warm%20lighting&width=600&height=400&seq=gallery_chohem_03&orientation=landscape',
    alt: 'Kiosk dịch vụ làm móng',
    span: 'col-span-1 row-span-1',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Asian%20clothing%20kiosk%20stall%20colorful%20traditional%20garments%20silk%20fabrics%20hanging%20display%20organized%20boutique%20small%20shop%20warm%20lighting&width=600&height=400&seq=gallery_chohem_04&orientation=landscape',
    alt: 'Kiosk quần áo vải vóc',
    span: 'col-span-1 row-span-1',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Asian%20kitchen%20utensils%20kiosk%20ceramic%20bowls%20chopsticks%20tea%20sets%20bamboo%20products%20display%20wooden%20shelves%20warm%20lighting%20organized&width=600&height=400&seq=gallery_chohem_05&orientation=landscape',
    alt: 'Kiosk dụng cụ nhà bếp',
    span: 'col-span-1 row-span-1',
  },
];

const GallerySection = () => {
  const { t } = useTranslation('choHem');

  return (
    <section className="py-14 md:py-24 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-amber-500/15 border border-amber-400/30 rounded-full text-xs text-amber-300 font-semibold uppercase tracking-wider mb-3">
            {t('gallery.badge')}
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white font-serif mb-3">
            {t('gallery.title')} <span className="text-amber-400">{t('gallery.titleHighlight')}</span>
          </h2>
          <p className="text-gray-400 text-sm md:text-base max-w-xl mx-auto">
            {t('gallery.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 auto-rows-[180px] md:auto-rows-[220px]">
          {images.map((img, i) => (
            <div
              key={i}
              className={`${img.span} rounded-2xl overflow-hidden border border-white/10 group`}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;